import React, { useState, useEffect } from 'react';
import { DateRangePicker } from 'react-date-range';

const Reserve = ({ propertyId }) => {
  const [bookings, setBookings] = useState([])
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  })

  useEffect(() => {
    fetch(`https://f3mw4bb5.directus.app/items/Bookings?limit=60&fields[]=id&fields[]=property&fields[]=startDate&fields[]=endDate&sort=id&filter={"property": "${propertyId}"}`)
      .then(response => response.json())
      .then(result => {
        const trasformData = result?.data.map(rawBookins => {
          const dates = {
            startDate: new Date(rawBookins.startDate),
            endDate: new Date(rawBookins.endDate),
            disabled: true,
            key: `${rawBookins.id}`,
            color: '#000'
          }
          return dates
        })
        setBookings(trasformData)
      })
  }, [propertyId])

  const handleSelectRangeDate = (ranges) => {
    setSelectionRange(prevState => ({ ...prevState, ...ranges.selection }))
    // {
    //   selection: {
    //     startDate: [native Date Object],
    //     endDate: [native Date Object],
    //   }
    // }
  }

  const handleSubmit = (formdata) => {
    const dataToSubmit = {
      ...formdata,
      property: propertyId,
      startDate: selectionRange.startDate,
      endDate: selectionRange.endDate
    }
    fetch('https://f3mw4bb5.directus.app/items/Bookings',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(dataToSubmit)
      })
      .then(result => {
        console.log(result)
        alert("booking save successful")
      })
  }

  return (
    <div>
      <h4 className="title-2">Reserve</h4>
      <DateRangePicker
        className="super-daterange"
        minDate={new Date()}
        ranges={[selectionRange, ...bookings]}
        onChange={handleSelectRangeDate}
      />
      <form action="#" onSubmit={(event) => {
        event.preventDefault();
        const { comments, name, email, phone } = event.target.elements
        handleSubmit({ comments: comments.value, name: name.value, email: email.value, phone: phone.value})
      }}>
        <div className="input-item input-item-textarea ltn__custom-icon">
          <textarea name="comments" placeholder="Type your comments...." defaultValue={""} />
        </div>
        <div className="input-item input-item-name ltn__custom-icon">
          <input name="name" type="text" placeholder="Type your name...." />
        </div>
        <div className="input-item input-item-email ltn__custom-icon">
          <input name="email" type="email" placeholder="Type your email...." />
        </div>
        <div className="input-item input-item-phone ltn__custom-icon">
          <input name="phone" type="text" placeholder="Type your phone...." />
        </div>
        <div className="btn-wrapper">
          <button className="btn theme-btn-1 btn-effect-1 text-uppercase" type="submit">
            {/* <i className="far fa-comments" /> */}
            Reserve
          </button>
        </div>
      </form>
    </div>
  )
}

export default Reserve;
